import { CompanyOnboardingStrings } from "@/screen/Companies/companyOnboarding.strings";

export interface CompanyDetailsSection
{
    id: string;
    number: number;
    title: string;
}

// Secciones del paso 3, en el orden de la pantalla (índice lateral y tarjetas numeradas)
export const CompanyDetailsSections: CompanyDetailsSection[] =
[
    { id: "company-basic-info", number: 1, title: CompanyOnboardingStrings.basicInfoTitle },
    { id: "company-registry", number: 2, title: CompanyOnboardingStrings.registryTitle },
    { id: "company-addresses", number: 3, title: CompanyOnboardingStrings.addressesTitle },
    { id: "company-contact", number: 4, title: CompanyOnboardingStrings.contactTitle },
    { id: "company-documents", number: 5, title: CompanyOnboardingStrings.documentsTitle },
    { id: "company-representatives", number: 6, title: CompanyOnboardingStrings.representativesTitle },
];

/**
 * Sección activa del índice: la última cuyo borde superior ya ha pasado la línea de lectura (offset px desde arriba).
 * Al principio de la página es la primera; si se ha llegado al final, la última aunque no alcance la línea.
 */
export function getActiveSectionIndex(sectionTops: number[], offset: number, reachedBottom: boolean): number
{
    if(sectionTops.length === 0)
    {
        return 0;
    }
    if(reachedBottom)
    {
        return sectionTops.length - 1;
    }

    let active = 0;
    sectionTops.forEach((top, index) =>
    {
        if(top <= offset)
        {
            active = index;
        }
    });
    return active;
}
